import { render, staticRenderFns } from "./Skeleton.vue?vue&type=template&id=581c9b38&scoped=true"
import script from "./Skeleton.vue?vue&type=script&lang=js"
export * from "./Skeleton.vue?vue&type=script&lang=js"
import style0 from "./Skeleton.vue?vue&type=style&index=0&id=581c9b38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581c9b38",
  null
  
)

export default component.exports